// Material-UI
import { Button, Grid, Typography, styled } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { openWindow } from "src/redux/actions/Mosaic.Actions";
import { SwitchField } from "src/components/FormikComponents/SwitchField";
import { IRootState } from "src/redux/reducers/CombinedReducers";
import { setHideDropOffHours } from "src/redux/actions/CrewSchedule/CrewSchedule.Actions";
import { IconButton } from "src/components/IconButton/IconButton";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

interface ICrewScheduleActionsProps {
  windowId: string;
  setTabValue: React.Dispatch<React.SetStateAction<string | boolean>>;
}

const OCCrewScheduleActions = styled("div")(({ theme }) => ({
  display: "flex",
  padding: 10,
  flexFlow: "row",
  "& .heading": {
    display: "contents",
  },
  "& .control": {
    display: "inline-flex",
    margin: 5,
    padding: 5,
    backgroundColor: theme.custom.forms.inputBack,
    borderRadius: 5,
    alignItems: "center",
    "& .control_action": {
      fontSize: 12,
      maxWidth: 150,
      margin: "0px 8px",
    },
  },
  "& .control_action_command": {
    display: "flex",
    "& .add_icon": {
      color: theme.palette.primary.main,
    },
  },
  "& .dropoff_switch": {
    width: "auto",
    height: 30,
    margin: 5,
    "& .dropoff_switch_label": { width: 210 },
    "& .dropoff_switch_control": { margin: 0 },
  },
}));

/**
 *  Crew Sched Actions
 *  Will display any actions available.
 */
export const CrewScheduleActions = (props: ICrewScheduleActionsProps): JSX.Element => {
  const { setTabValue } = props;
  const dispatch = useDispatch();

  const hideDropOffHours = useSelector((state: IRootState) => state.crewSchedule.hideDropOffHours);

  const openFlightPairingStatusWindow = (): void => {
    dispatch(openWindow("Flight Pairing Status", "FlightPairingStatusWindow", [], {}, "content"));
  };

  const openFlightPairingStatusV2Window = (): void => {
    // v2 of the tool (cached, event-driven status). The original window above stays until v2 is adopted.
    // One window: a second click focuses the open one instead of opening a competing copy.
    dispatch(openWindow("Flight Pairing Status v2", "FlightPairingStatusV2Window", [], {}, "content", true));
  };

  const openPairingCheckInStatusWindow = (): void => {
    dispatch(openWindow("Check-In Status", "PairingCheckInStatusWindow", [], {}, "content"));
  };

  const openCrewLedgerWindow = (): void => {
    dispatch(openWindow("Crew Pairing Change Ledger", "CrewPairingLedgerWindow", [], {}, "content"));
  };

  /**
   * toggleHideDropOffHours - Dispatches redux to toggle whether or not to show drop off hours
   */
  const toggleHideDropOffHours = (): void => {
    dispatch(setHideDropOffHours(!hideDropOffHours));
  };

  return (
    <OCCrewScheduleActions>
      <IconButton style={{ paddingBottom: "4px", marginRight: "15px" }} onClick={() => setTabValue(false)}>
        <VisibilityOffIcon fontSize="small" />
      </IconButton>
      <Button id={"swap_aircraft_events_btn"} variant="outlined" onClick={openFlightPairingStatusWindow}>
        Flight Pairing Status
      </Button>
      <Button id={"flight_pairing_status_v2_btn"} variant="outlined" onClick={openFlightPairingStatusV2Window}>
        Flight Pairing Status v2
      </Button>
      <Button id={"pairing_checkIn_events_btn"} variant="outlined" onClick={openPairingCheckInStatusWindow}>
        Check-In Status
      </Button>
      <Button id={"crew_ledger_btn"} variant="outlined" onClick={openCrewLedgerWindow}>
        Crew Pairing Change Ledger
      </Button>
      <Grid className="dropoff_switch" container direction="row" wrap="nowrap" alignItems="center">
        <Typography variant="subtitle1" className="dropoff_switch_label">
          Hide Drop off hours
        </Typography>
        <SwitchField
          className="dropoff_switch_control"
          name="subaircraftSwitch"
          value={hideDropOffHours}
          onChange={toggleHideDropOffHours}
          switchlabels={["Hide", "Show"]}
          switchtooltips={["Hide Drop off hours", "Show Drop off hours"]}
          label=""
          allowNull={false}
        />
      </Grid>
    </OCCrewScheduleActions>
  );
};
